<script lang="ts">
import { defineComponent } from 'vue'

import BaseCard from './BaseCard.vue'

/**
 * A card to display a Prize.
 *
 */
export default defineComponent({
  components: {
    BaseCard,
  },
})
</script>

<template>
  <BaseCard class="gap-0 p-0">
    <slot name="title"></slot>
    <slot name="image"></slot>
    <div class="px-3 @sm/main:px-4 pb-2 @sm/main:pb-3">
      <slot></slot>
    </div>
  </BaseCard>
</template>
